import { defineStore } from 'pinia';
import { api } from '../services/api';
import type { CurrentUser, Language, LoginResponse, LoginUser } from '../types/api';

export const useAuth = defineStore('auth', {
  state: () => ({ user: null as CurrentUser | LoginUser | null, loading: false }),
  getters: {
    company: state => state.user && 'memberships' in state.user ? state.user.memberships[0]?.company : undefined,
    area(state) {
      if (state.user?.platformRole === 'ADMIN') return 'admin';
      return state.user && 'memberships' in state.user ? state.user.memberships[0]?.company.type?.toLowerCase() : undefined;
    }
  },
  actions: {
    async login(email: string, password: string) {
      const response = await api.post<LoginResponse>('/auth/login', { email, password });
      sessionStorage.setItem('bralink_access', response.data.accessToken);
      this.user = response.data.user;
      await this.load();
    },
    async load() {
      if (!sessionStorage.getItem('bralink_access')) return;
      try {
        this.user = (await api.get<CurrentUser>('/me')).data;
      } catch {
        this.user = null;
      }
    },
    async setPreferredLanguage(language: Language) {
      const response = await api.patch<CurrentUser>('/me', { preferredLanguage: language });
      this.user = response.data;
      return response.data;
    },
    logout() {
      sessionStorage.removeItem('bralink_access');
      this.user = null;
      void api.post('/auth/logout');
    }
  }
});
